export default __webpack_public_path__ + "21707201c9bbd62f0936d20aee634d12.png";